import React from 'react'
import Transition from 'react-transition-group/Transition'
import { withRouter } from 'react-router'
import isEqual from 'lodash.isequal'

import Markdown from '../Markdown/markdown'

import './accordion.scss'

class Accordion extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openedItems: this.props.openedItems || {}, 
      currentAnchor: ''
    }

    this.toggleHandler = this.toggleHandler.bind(this)
    this.updateOpenedItems = this.updateOpenedItems.bind(this)

    this.anchors = {}
    this.props.content.items.forEach((item, index) => {
      if (item.anchor) {
        this.anchors[item.anchor] = [`${index}`]
      }

      if (item.subItems) {
        item.subItems.forEach((subItem, subIndex) => {
          this.anchors[subItem.anchor] = [`${index}`, `${index}.${subIndex}`]
        })
      }
    })
  }

  componentDidMount() {
    this.hasScrolled = false
    this.updateOpenedItems()
  }


  componentDidUpdate(oldProps) {    
    if (!isEqual(this.props.openedItems, oldProps.openedItems)) {
      this.setState({
        openedItems: this.props.openedItems
      })
    } else if (this.props.location.hash && this.state.currentAnchor !== this.props.location.hash) {
      this.updateOpenedItems()
    }

    if (!this.hasScrolled && this.props.location.hash) {
      this.scrollToItem()
      this.hasScrolled = true
    }
  }

  scrollToItem() {
    setTimeout(() => {
      const id = `#item-${this.props.location.hash.substring(1)}`

      const element = document.querySelector(id)
      if (element) {
        window.scrollTo(0, element.offsetTop)
      }
    }, 500)
  }

  updateOpenedItems() {
    const anchor = this.props.location.hash.substring(1)

    if (anchor in this.anchors) {
      const items = this.anchors[anchor]
      const openedItems = { ...this.state.openedItems }
      items.forEach(item => openedItems[item] = true)
        
      this.setState({
        currentAnchor: this.props.location.hash,
        openedItems
      })
    }
  }

  toggleHandler(index) {
    const key = `${index}`
    const openedItems = { ...this.state.openedItems }

    openedItems[key] = !openedItems[key]

    this.setState({
      openedItems
    })
  }

  renderSubItem(item, index) {
    const anchor = item.anchor ? `item-${item.anchor}` : null

    return (
      <div key={item.id} id={anchor}>
        <dt className="accordion-sub-title" onClick={() => this.toggleHandler(index)}>
          { item.title }
        </dt>
        { this.state.openedItems[index] ? 
            <dd className="accordion-sub-content">
              { item.content ? <Markdown content={ item.content.content } highlightWord={ this.props.highlightWord } /> : '' }
            </dd> 
          : null
        }
      </div>
    )
  }

  renderItem(item, index, state) {
    const classes = `accordion-content nested ${state}`
    if (item.subItems) {
      return (
        <dd className={ classes }>
          <dl className="subitems-container">
            { item.subItems.map((subItem, subIndex) => this.renderSubItem(subItem, `${index}.${subIndex}`)) }
          </dl>
        </dd>
      )
    } else {
      const anchor = item.anchor ? `#item-${item.anchor}` : null
      return (
        <dd className={ classes } id={ anchor }>
          { item.content ? <Markdown content={ item.content.content } highlightWord={ this.props.highlightWord } /> : '' }
        </dd>
      ) 
    }
  }

  renderContent(content)  {
    if (content) {
      return (
        <div className="text-content">
          <h3 className="heading">
            {content.heading}
          </h3>
          <div className="content">
            {content.body.body}
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  render() {
    const contentBlock = this.renderContent(this.props.content.content)

    return (
      <div className="standard-container accordion-container" data-cy="accordion">
        { contentBlock }

        <div className={`accordion-wrapper ${!contentBlock ? 'accordion-fullwidth': ''}`}>
          <dl>
            {this.props.content.items.map((item, index) => {
              const expandedClass = this.state.openedItems[index] ? 'expanded' : ''
              return (
                <div key={item.id}>
                  <dt className={ `accordion-title ${expandedClass}` }
                      onClick={() => this.toggleHandler(index)}>
                    <span className="accordion-title-text">{ item && item.title ? item.title : '' }</span>
                  </dt>
                  <Transition
                    in={this.state.openedItems[index]}
                    timeout={{enter: 500, exit: 500}}>
                    {state => state !== 'exited' ? this.renderItem(item, index, state) : null }
                  </Transition>
                </div>
              )
            })}
          </dl>
         </div>
      </div>
    )
  }
}

 
export default withRouter(Accordion)



// WEBPACK FOOTER //
// ./src/components/Accordion/accordion.js